<template>
  <div>
    <!--    <h3> 操作记录：</h3>-->
    <!--    <el-divider></el-divider>-->
    <el-timeline class='opt-log'>
      <el-timeline-item
        :color='activity.color'
        :key='index'
        v-for='(activity, index) in divideLog'
      >
        {{ activity.msg }}<span style='float: right'>{{activity.created_at}}</span>
      </el-timeline-item>
    </el-timeline>
    <div>
      <el-link icon='el-icon-refresh' @click='getList'>刷新日志</el-link>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ArtistCommissionComponentsLogList',
  data() {
    return {
      divideLog: []
    }
  },
  props: {
    divideId: {
      type: [String, Number]

    }
  },
  methods: {
    async getList() {
      const divideLog = await this.$api.getArtistDividelog({ divide_id: this.divideId })
      // "op_type": "create", //操作类型 create:创建 #0bbd87 confirm:确认 #409EFF check:审核 #F56C6C notify:通知 #E6A23C

      divideLog.list.forEach((itme) => {
          switch (itme.op_type) {
            case  'import-divide':
              itme.color = '#0bbd87'
              break
            case  'check':
              itme.color = '#0bbd87'
              break
            case  'confirm':
              itme.color = '#409EFF'
              break
            case  'finance-notify':
              itme.color = '#F56C6C'
              break
            case  'assistant-notify':
              itme.color = '#E6A23C'
              break
            case  'update':
              itme.color = '#409EFF'
              break
          }
        },
        this.$nextTick(() => {
          this.divideLog = divideLog.list
        })
      )
    }
  },
  created() {
    if (this.divideId)
      this.getList()
  }
}
</script>

<style scoped>
.opt-log {
  max-width: 800px;
  height: auto;
  max-height: 400px;
  min-height: 100px;
  overflow: scroll;
  //border-top: 1px solid #EBEEF5;
  padding: 10px;
}

</style>
